import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import InputIcon from '@mui/icons-material/Input';
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import BoolSetting from "../../../../../../../components/global/Settings/BoolSetting";
import NumberSetting from "../../../../../../../components/global/Settings/NumberSetting";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";
import { useGetEnumsQuery, useGetSettingsForRelationQuery, useGetSettingsQuery } from "../../../../../../../newapi/global/generalApiSlice";


const Relation = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { data: settings} = useGetSettingsForRelationQuery();
  const { data: relationEditProductDimensions} = useGetSettingsQuery("relation_edit_product_dimensions");
  // The switch and the day count behind archiving relations that stop receiving orders. They
  // share the tab's Save button: a half-typed day count would archive relations far too soon.
  const { data: autoInactiveSettings } = useGetSettingsQuery("relation_auto_inactive");
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();

  const { data: globalEnums, enumIsLoading } = useGetEnumsQuery();

  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);


  return (
    <Box
      sx={{
        
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
          overflow:"auto",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 4,
          // overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            // background:"purple",
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_relation_heading")}</Subheading>
            <Text light>{t("core_relation_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>

        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 48em)": {
              pb:10,
              overflow:"auto",
              // display:"none"
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              padding: 3,
              display:"flex",
              flexDirection:"column",
              gap:3,
              borderTopRightRadius:16,
              borderTopLeftRadius:16,
              "@media screen and (max-width: 48em)": {
                gap:2.5,
              },
            }}
          >
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_products" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_orders" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_inbound" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_return" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_invoices" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_integrations" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_access" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_suppliers" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="page_servicedesk" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={relationEditProductDimensions} skey="relation_edit_product_dimensions"/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_import_order" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_allocate_stock_backorders" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_allow_b2b" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_edit_product_instructions" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_block_barcode_removal" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_show_countingstrategies" relationId={-1}/>
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_packaging_usage_export" relationId={-1}/>
            <Subheading>{t("core_relation_auto_inactive_title")}</Subheading>
            <Text light>{t("core_relation_auto_inactive_subtitle")}</Text>
            <BoolSetting manualSave onChange={handleChange} settings={autoInactiveSettings} skey="relation_auto_inactive_enabled"/>
            <NumberSetting
              manualSave
              hideSaveButton
              maxWidth={240}
              settings={autoInactiveSettings}
              skey="relation_auto_inactive_days"
              onChange={handleChange}
            />
            <BoolSetting manualSave onChange={handleChange} settings={settings} skey="relation_allow_lvb_pick_date" relationId={-1}/>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Relation;
